import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Settings|Affiliation|Template|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.CandidateProfilePrimaryInformationAffiliation,
	portal: 'SP',
};

type LocNameStart = 'SPSettingsAffiliationTemplate';
export type SPSettingsAffiliationTemplateLocNames = `${LocNameStart}ButtonDownload`;

export const spSettingsAffiliationTemplateLocs: LocDefs<SPSettingsAffiliationTemplateLocNames> = {
	SPSettingsAffiliationTemplateButtonDownload: {
		defaultValue: 'Download Affiliation Template',
		description: 'Download Affiliation Template button',
		displayPath: `${pathStart}Download Affiliation Template`,
		displayType: 'Button',
		legacyName:
			'CandidateProfile.PrimaryInformation.Affiliation/Settings.AffiliationImport.Button.Template',
		...sharedProperties,
	},
};

export type SPSettingsAffiliationTemplateLocType = LocMap<SPSettingsAffiliationTemplateLocNames>;
